import Importing from "./importer"

export default {
    __init__: [ 'importing' ],
    importing: [ 'type', Importing ]
}